import { getBrandEmail } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerEmail } from "@faire/help-center-utils/serialized-data/getRetailer";
import {
  getUserEmail,
  getUserFullName,
  getUserPhoneNumber,
} from "@faire/help-center-utils/serialized-data/getUser";

import { useScrollToTopOnLoadEffect } from "./useScrollToTopEffect";
import { useSelectedBrandOrderNumber } from "./useSelectedBrandOrderNumber";
import { useSelectedOrderToken } from "./useSelectedOrderToken";

export interface ICallRequestForm {
  name: string;
  email: string;
  phone: string;
  brandOrderNumber: string;
  details: string;
  orderToken: string;
}

export const useInitializeCallRequestField = () => {
  const userFullName = getUserFullName();
  const emailAddress = getRetailerEmail() ?? getBrandEmail() ?? getUserEmail();
  const phoneNumber = getUserPhoneNumber();
  const selectedBrandOrderNumber = useSelectedBrandOrderNumber();
  const selectedOrderToken = useSelectedOrderToken();

  useScrollToTopOnLoadEffect(10);

  const callRequestInitial: ICallRequestForm = {
    name: userFullName,
    email: emailAddress,
    phone: phoneNumber,
    brandOrderNumber: selectedBrandOrderNumber,
    details: "",
    orderToken: selectedOrderToken,
  };
  return { callRequestInitial };
};
